// The default number of days that an announcement will stay in the feed past its date
export const DEFAULT_ANNOUNCEMENT_DAYS_TO_DISPLAY = 30;
